import React, { useState } from 'react';
import { 
  Building, 
  Plus, 
  Search, 
  Users, 
  Pencil, 
  Trash2, 
  ChevronDown, 
  ChevronUp,
  Info,
  CheckCircle2
} from 'lucide-react';
import './Insurances.css';

const Insurances = () => {
  const [expandedId, setExpandedId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const initialList = [
    { id: 1, name: 'A B G', sigla: 'ABG', cuit: '30-71112223-9', active: true, plans: ['Plan 210', 'Plan 310'] },
    { id: 2, name: 'OSDE', sigla: 'OSD', cuit: '30-54666777-1', active: true, plans: ['Binario', '210', '310', '410', '450', '510'] },
    { id: 3, name: 'SWISS MEDICAL', sigla: 'SWM', cuit: '30-66777888-2', active: true, plans: ['Nubial', 'SMG02', 'SMG20', 'SMG40', 'SMG50'] },
    { id: 4, name: 'GALENO', sigla: 'GAL', cuit: '30-50000111-3', active: true, plans: ['Blanco', 'Azul', 'Plata', 'Oro'] },
    { id: 5, name: 'MEDICUS', sigla: 'MED', cuit: '30-55555444-4', active: true, plans: ['Azul', 'Celeste', 'Family'] },
    { id: 6, name: 'OMINT', sigla: 'OMI', cuit: '30-56666777-8', active: true, plans: ['O', 'F', 'S', 'Premium'] },
    { id: 7, name: 'MEDIFE', sigla: 'MDF', cuit: '30-67777888-9', active: true, plans: ['Bronce', 'Plata', 'Oro', 'Platinum'] },
    { id: 8, name: 'SANCOR SALUD', sigla: 'SNC', cuit: '30-58888999-0', active: true, plans: ['1000', '2000', '3000', '4000'] },
    { id: 9, name: 'ACCORD SALUD', sigla: 'ACC', cuit: '30-59999000-1', active: true, plans: ['Accord 110', 'Accord 210', 'Accord 310'] },
    { id: 10, name: 'PAMI', sigla: 'PAM', cuit: '30-52222333-4', active: true, plans: ['General', 'Especialista'] },
    { id: 11, name: 'IOMA', sigla: 'IOM', cuit: '30-63333444-5', active: true, plans: ['General', 'Accesorios'] },
    { id: 12, name: 'UNIÓN PERSONAL', sigla: 'UP', cuit: '30-64444555-6', active: true, plans: ['Classic', 'Familiar', 'Accord'] },
    { id: 13, name: 'PREVENCION SALUD', sigla: 'PRV', cuit: '30-65555666-7', active: true, plans: ['A1', 'A2', 'A3', 'A4'] },
    { id: 14, name: 'HOMIC', sigla: 'HOM', cuit: '30-66666777-8', active: true, plans: ['H1', 'H2', 'H3'] },
    { id: 15, name: 'OSECAC', sigla: 'OSE', cuit: '30-67777888-9', active: true, plans: ['General'] },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingIns, setEditingIns] = useState(null);
  const [insForm, setInsForm] = useState({ name: '', sigla: '', cuit: '', plans: '' });

  const [insuranceList, setInsuranceList] = useState(() => {
    try {
      const saved = localStorage.getItem('gdt_insurances');
      const parsed = saved ? JSON.parse(saved) : null;
      return (parsed && Array.isArray(parsed)) ? parsed : initialList;
    } catch(e) { return initialList; }
  });

  const handleSave = () => {
    const plansArr = insForm.plans.split(',').map(p => p.trim()).filter(Boolean);
    let newList;
    if (editingIns) {
      newList = insuranceList.map(i => i.id === editingIns.id ? { ...i, name: insForm.name, sigla: insForm.sigla, cuit: insForm.cuit, plans: plansArr } : i);
    } else {
      newList = [...insuranceList, { id: Date.now(), name: insForm.name, sigla: insForm.sigla, cuit: insForm.cuit, active: true, plans: plansArr }];
    }
    setInsuranceList(newList);
    localStorage.setItem('gdt_insurances', JSON.stringify(newList));
    setIsModalOpen(false);
  };

  const handleDelete = (id) => {
    if (window.confirm('¿Seguro que deseas eliminar esta obra social?')) {
      const newList = insuranceList.filter(i => i.id !== id);
      setInsuranceList(newList);
      localStorage.setItem('gdt_insurances', JSON.stringify(newList));
    }
  };

  const openModal = (ins) => {
    if (ins) {
      setEditingIns(ins);
      setInsForm({ name: ins.name, sigla: ins.sigla, cuit: ins.cuit, plans: ins.plans ? ins.plans.join(', ') : '' });
    } else {
      setEditingIns(null);
      setInsForm({ name: '', sigla: '', cuit: '', plans: '' });
    }
    setIsModalOpen(true);
  };


  const filteredInsurances = insuranceList.filter(ins => 
    ins.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    ins.sigla.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="insurances-page">
      {isModalOpen && (
        <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.8)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center'}}>
          <div style={{background:'#1a1b23', padding:'30px', borderRadius:'12px', width:'90%', maxWidth:'450px', border:'1px solid rgba(255,255,255,0.1)'}}>
            <h2 style={{marginTop:0, marginBottom:'20px', color:'#fff'}}>{editingIns ? 'Editar' : 'Nueva'} Obra Social</h2>
            <div style={{display:'flex', flexDirection:'column', gap:'15px'}}>
              <div>
                <label style={{display:'block', fontSize:'12px', color:'#aaa', marginBottom:'5px'}}>NOMBRE</label>
                <input type="text" value={insForm.name} onChange={(e) => setInsForm({...insForm, name: e.target.value})} style={{width:'100%', padding:'10px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', color:'#fff', borderRadius:'6px'}} />
              </div>
              <div>
                <label style={{display:'block', fontSize:'12px', color:'#aaa', marginBottom:'5px'}}>SIGLA</label>
                <input type="text" value={insForm.sigla} onChange={(e) => setInsForm({...insForm, sigla: e.target.value})} style={{width:'100%', padding:'10px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', color:'#fff', borderRadius:'6px'}} />
              </div>
              <div>
                <label style={{display:'block', fontSize:'12px', color:'#aaa', marginBottom:'5px'}}>CUIT</label>
                <input type="text" value={insForm.cuit} onChange={(e) => setInsForm({...insForm, cuit: e.target.value})} style={{width:'100%', padding:'10px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', color:'#fff', borderRadius:'6px'}} />
              </div>
              <div>
                <label style={{display:'block', fontSize:'12px', color:'#aaa', marginBottom:'5px'}}>PLANES (Separados por coma)</label>
                <input type="text" value={insForm.plans} onChange={(e) => setInsForm({...insForm, plans: e.target.value})} placeholder="Plan 210, Plan 310" style={{width:'100%', padding:'10px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', color:'#fff', borderRadius:'6px'}} />
              </div>
              <div style={{display:'flex', justifyContent:'flex-end', gap:'10px', marginTop:'15px'}}>
                <button onClick={() => setIsModalOpen(false)} style={{padding:'10px 15px', background:'transparent', border:'none', color:'#ccc', cursor:'pointer'}}>Cancelar</button>
                <button onClick={handleSave} style={{padding:'10px 20px', background:'#00e5ff', color:'#000', border:'none', borderRadius:'6px', fontWeight:'bold', cursor:'pointer'}}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="insurances-header">
        <div className="insurances-title-main">
          <Building size={32} className="insurances-icon-primary" />
          <h1>Obras Sociales / Seguros Médicos</h1>
        </div>
        <button className="btn-new-insurance" onClick={() => openModal()}>
          NUEVA OBRA SOCIAL <Plus size={18} />
        </button>
      </div>

      <div className="insurances-controls card">
        <div className="search-bar-wrapper">
          <Search size={18} className="search-icon" />
          <input 
            type="text" 
            placeholder="Buscar por nombre o sigla (Ej: OSDE, Swiss, etc...)" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="insurances-table-container card">
        <table className="insurances-table">
          <thead>
            <tr>
              <th>Descripción <ChevronUp size={14} className="sort-icon" /></th>
              <th className="text-center">Staff que Atiende</th>
              <th className="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredInsurances.map(insurance => (
              <React.Fragment key={insurance.id}>
                <tr className={expandedId === insurance.id ? 'row-expanded-header' : ''}>
                  <td className="clickable-name" onClick={() => toggleExpand(insurance.id)}>
                    <div className="name-with-cuit">
                      <span className="ins-main-name">{insurance.name}</span>
                      <span className="ins-sub-cuit">CUIT: {insurance.cuit}</span>
                    </div>
                  </td>
                  <td className="text-center">
                    <div className="staff-avatars-list">
                      <div className="staff-avatar-circle-v2 green" title="Dr. Juan Sanchez">JS</div>
                      <div className="staff-avatar-circle-v2 blue" title="Dra. Maria Lopez">ML</div>
                    </div>
                  </td>
                  <td className="text-center">
                    <div className="insurances-actions">
                      <button className="btn-ins-edit" title="Editar" onClick={(e) => { e.stopPropagation(); openModal(insurance); }}><Pencil size={18} /></button>
                      <button className="btn-ins-delete" title="Eliminar" onClick={(e) => { e.stopPropagation(); handleDelete(insurance.id); }}><Trash2 size={18} /></button>
                    </div>
                  </td>
                </tr>
                {expandedId === insurance.id && (
                  <tr className="ins-detail-row">
                    <td colSpan="3">
                      <div className="ins-detail-content">
                        <div className="ins-info-grid">
                          <div className="ins-info-item">
                            <span className="info-label">Sigla:</span>
                            <span className="info-value">{insurance.sigla}</span>
                          </div>
                          <div className="ins-info-item">
                            <span className="info-label">CUIT:</span>
                            <span className="info-value">{insurance.cuit}</span>
                          </div>
                          <div className="ins-info-item">
                            <span className="info-label">Estado:</span>
                            <span className="info-value text-green"><CheckCircle2 size={14} /> ACTIVO</span>
                          </div>
                        </div>
                        
                        <div className="plans-section">
                          <h3>Planes y Coseguros Habilitados</h3>
                          <table className="plans-table">
                            <thead>
                              <tr>
                                <th>Plan</th>
                                <th>Coseguro General</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {insurance.plans.map((plan, idx) => (
                                <tr key={idx}>
                                  <td className="plan-name-cell">{plan}</td>
                                  <td>$ 0.00</td>
                                  <td><span className="status-tag active">Vigente</span></td>
                                  <td><Pencil size={14} className="text-cyan cursor-pointer" /></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <button className="btn-add-plan">+ AGREGAR NUEVO PLAN</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Insurances;

